import React from "react";

const PageLoader = () => {
	return (
		<div
			className='flex min-h-[50vh] flex-col items-center justify-center gap-3 text-brand'
			role='status'
			aria-live='polite'
			aria-label='Loading page'
		>
			<div className='h-10 w-10 animate-spin rounded-full border-4 border-surface-muted border-t-brand-accent' />
			<p className='text-sm font-medium text-brand-muted'>Loading…</p>
		</div>
	);
};

export default PageLoader;
